import LocaleStore from './LocaleStore';
import CommentStore from './CommentStore';
import BottomCommentStore from './BottomCommentStore';
import RedPackStore from './RedPackStore';
import UIStore from './UIStore';
import VideoCommentStore from './VideoCommentStore';
import GalleryStore from './GalleryStore';
import WxUserStore from './WxUserStore';
import CommonStore from './CommonStore';
import RelationStore from './RelationStore';
import PagedataStore from './PagedataStore';
import IMStore from './IMStore';
import VideoStore from './VideoStore';
import CommentV2Store from './CommentV2Store';
import DocumentStore from './DocumentStore';
import VoteStore from './VoteStore';
import LuckyStore from './LuckyStore';

export interface IRootStore {
  localeStore: LocaleStore;
  commentStore: CommentStore;
  redPackStore: RedPackStore;
  uiStore: UIStore;
  videoCommentStore: VideoCommentStore;
  galleryStore: GalleryStore;
  relationStore: RelationStore;
  commonStore: CommonStore;
  wxuserStore: WxUserStore;
  pagedataStore: PagedataStore;
  imStore: IMStore;
  videoStore: VideoStore;
  commentV2Store: CommentV2Store;
  documentStore: DocumentStore;
  voteStore: VoteStore;
  luckyStore: LuckyStore;
}

export default class RootStore implements IRootStore {
  public localeStore: LocaleStore;
  public commentStore: CommentStore;
  public bottomCommentStore: BottomCommentStore;
  public redPackStore: RedPackStore;
  public uiStore: UIStore;
  public videoCommentStore: VideoCommentStore;
  public galleryStore: GalleryStore;
  public wxuserStore: WxUserStore;
  public commonStore: CommonStore;
  public relationStore: RelationStore;
  public pagedataStore: PagedataStore;
  public imStore: IMStore;
  public videoStore: VideoStore;
  public commentV2Store: CommentV2Store;
  public documentStore: DocumentStore;
  public voteStore: VoteStore;
  public luckyStore: LuckyStore;

  constructor() {
    this.localeStore = new LocaleStore(this);
    this.commentStore = new CommentStore(this);
    this.bottomCommentStore = new BottomCommentStore(this);
    this.redPackStore = new RedPackStore(this);
    this.uiStore = new UIStore(this);
    this.videoCommentStore = new VideoCommentStore(this);
    this.imStore = new IMStore(this);
    this.galleryStore = new GalleryStore(this);
    this.wxuserStore = new WxUserStore(this);
    this.commonStore = new CommonStore(this);
    this.relationStore = new RelationStore(this);
    this.pagedataStore = new PagedataStore(this);
    this.videoStore = new VideoStore(this);
    this.commentV2Store = new CommentV2Store(this);
    this.documentStore = new DocumentStore(this);
    this.voteStore = new VoteStore(this);
    this.luckyStore = new LuckyStore(this);
  }
}
